import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { DesignElementBase, DesignElementBrandedPart, DesignElementGroupablePart, DesignElementSlugPart } from "./base";
import { ElementGroupDataV2 } from "./data";
import { DesignElementType } from "./raw-element";

export const ElementGroup = DesignElementBase.extend(DesignElementGroupablePart.shape)
  .extend(DesignElementSlugPart.shape)
  .extend(DesignElementBrandedPart.partial().shape)
  .extend({
    shortPersistentId: z.string().optional(),
    childType: DesignElementType,
    data: ElementGroupDataV2.optional(),
  });

export const BrandedElementGroup = ElementGroup.extend(DesignElementBrandedPart.shape);

export type ElementGroup = z.infer<typeof ElementGroup>;
export type BrandedElementGroup = z.infer<typeof BrandedElementGroup>;

export type CreateElementGroup = OmitStrict<DbCreateInputOmit<ElementGroup>, "parentPersistentId"> & {
  parentPersistentId: string;
};

export type UpdateElementGroup = DbUpdate<
  OmitStrict<ElementGroup, "brandPersistentId" | "childType" | "designSystemVersionId" | "parentPersistentId"> & {
    parentPersistentId: string;
  }
>;

export type RestoreElementGroup = OmitStrict<ElementGroup, "parentPersistentId"> & {
  parentPersistentId: string;
};

export type ElementGroupsDiff = {
  toCreate: CreateElementGroup[];
  toUpdate: UpdateElementGroup[];
  toDelete: ElementGroup["id"][];
};
